<div class="lock-status-container" *ngIf="hasData">
    <ion-icon *ngIf="isLocked" src="assets/images/locked.svg" class="lock-status-icon" tooltip="Locked" placement="top" (click)="onLockIconClick()"></ion-icon>
    <ion-icon *ngIf="!isLocked" src="assets/images/unlocked.svg" class="lock-status-icon" tooltip="Unlocked" placement="top" (click)="onLockIconClick()"></ion-icon>
</div>
